import ZoneGeoListBody from '@features/zonesGeo/ZonesGeoListBody';

function ZonesGeoList() {
  return <ZoneGeoListBody />;
}

export default ZonesGeoList;
